module.exports = __webpack_public_path__ + "img/2.ecd96c06.png";